var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 202,
    viewBox: "0 0 197 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_70_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0655 38.7707L77.5341 53.2495C77.5648 53.2669 77.5705 53.3088 77.5455 53.3338V53.3338C77.5246 53.3547 77.5246 53.3885 77.5455 53.4094L77.5854 53.4492C77.5923 53.4561 77.6001 53.4621 77.6085 53.4669L86.1639 58.3557C88.612 59.7546 88.612 62.0278 86.1639 63.4267L77.45 68.1322C77.4327 68.1415 77.4114 68.1384 77.3975 68.1246V68.1246C77.3834 68.1104 77.3614 68.1075 77.3441 68.1175L52.0655 82.6613C50.5449 83.3371 49.3508 83.3599 48.4832 82.572C48.4325 82.526 48.4327 82.4472 48.481 82.3988V82.3988C48.5294 82.3504 48.5292 82.2722 48.4835 82.2213C48.0066 81.6897 47.6941 80.8542 47.6941 79.8629V41.2187C47.6941 40.1999 47.859 39.346 48.3489 38.8171C48.3731 38.7909 48.414 38.7909 48.4394 38.8159V38.8159C48.4641 38.8401 48.5035 38.8406 48.5295 38.8177C49.3931 38.0562 50.5718 37.9409 52.0655 38.7707Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_70_18",
    x: 0.694092,
    y: 0.195923,
    width: 196.306,
    height: 200.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 31,
    dy: 40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.462745 0 0 0 0 0.541176 0 0 0 0.156863 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_70_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_70_18",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayicon);
export default __webpack_public_path__ + "static/media/playicon.855a458ec56d21943cc985e773b0dd87.svg";
export { ForwardRef as ReactComponent };